const $ = jQuery.noConflict();

const subnavDropdown = {
    trigger: $('.btn-subnav'),
    target: $('.main-header__subnav--dropdown'),

    hideOutsideClick(e) {
        if ( this.target.hasClass('active') ) {
            const container = this.target.parent();

            if ( !container.is(e.target) && container.has(e.target).length === 0 && !this.trigger.is(e.target) ) {
                this.hideDropdown();
            }
        }
    },

    showDropdown() {
        this.trigger.addClass('active');
        this.target.addClass('active');
    },

    hideDropdown() {
        this.trigger.removeClass('active');
        this.target.removeClass('active');
    },

    toggleDropdown() {
        if ( this.target.hasClass('active') ) {
            this.hideDropdown();
        } else {
            this.showDropdown();
        }
    },

    bindEvents() {
        this.trigger.on('click', () => {
            console.log('click');
            this.toggleDropdown();
        });
    },

    init() {
        this.bindEvents();
    }
}

export default subnavDropdown;